/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import AppConst from '../constants/app.constant';
import { getSettingFromLocalstorage } from '../services/localstorage/getSettingFromLocalstorage';
import { setSettingInLocalstorage } from '../services/localstorage/setSettingInLocalstorage';
import { getSettingValue } from '../services/utils/getSettingValue';
import { isShowingSideMenu } from '../services/utils/isShowingSideMenu';
import utilityService from '../services/utility.service';
import { isDeviceHavingUTCTimezone } from '../services/utils/isDeviceHavingUTCTimezone';
import d3 from '../globalexports/d3.export';

const applicationConfig = {
  isDeviceHavingUTCTimezone: false,
  showMobileView: null,
  is_iphone: null,
  imageryViewUseSubnav: null,
  settings: {
    timeZone: null,
    temperatureUnit: null,
    groundSpeed: null,
    synch7DayAirport: null,
    showBarbHead: null,
    mapStyle: null,
    ignoreMidpoints: null,
  },
};
applicationConfig.showMobileView = !isShowingSideMenu();
applicationConfig.imageryViewUseSubnav = !isShowingSideMenu();

applicationConfig.sanitizeTimeZone = () => {
  // If device timezone is utc then always use ZULU time
  applicationConfig.isDeviceHavingUTCTimezone = isDeviceHavingUTCTimezone();
  if (applicationConfig.isDeviceHavingUTCTimezone) {
    applicationConfig.settings.timeZone = AppConst.timeZones.zulu.key;
    applicationConfig.setapplicationConfig();
  }
};
applicationConfig.setapplicationConfig = () => {
  setSettingInLocalstorage(
    applicationConfig.settings,
    AppConst.localstorageConf.applicationSettingKey,
  );
};
applicationConfig.setDefaultSettings = () => {
  applicationConfig.settings = {
    timeZone: AppConst.timeZones.local.key,
    temperatureUnit: AppConst.temperatureUnits.fahrenheit.key,
    groundSpeed: AppConst.defaultGroundSpeed,
    synch7DayAirport: AppConst.defaultSynch7DayAirport,
    showBarbHead: AppConst.defaultShowBarbHead,
    mapStyle: AppConst.defaultMapStyle,
    ignoreMidpoints: AppConst.defaultIgnoreMidpoints,
  };
  setSettingInLocalstorage(
    applicationConfig.settings,
    AppConst.localstorageConf.applicationSettingKey,
  );
};
applicationConfig.loadApplicationConfig = () => {
  const myPreviousSettings = getSettingFromLocalstorage(
    AppConst.localstorageConf.applicationSettingKey,
  );
  if (!myPreviousSettings) {
    applicationConfig.setDefaultSettings();
  } else {
    applicationConfig.settings = {
      timeZone: getSettingValue(
        myPreviousSettings.timeZone,
        AppConst.timeZones.local.key,
      ),
      temperatureUnit: getSettingValue(
        myPreviousSettings.temperatureUnit,
        AppConst.temperatureUnits.fahrenheit.key,
      ),
      groundSpeed: getSettingValue(
        myPreviousSettings.groundSpeed,
        AppConst.defaultGroundSpeed,
      ),
      synch7DayAirport: getSettingValue(
        myPreviousSettings.synch7DayAirport,
        AppConst.defaultSynch7DayAirport,
      ),
      testSetting: getSettingValue(
        myPreviousSettings.testSetting,
        AppConst.defaultEnableCeilingSeries,
      ),
      showBarbHead: getSettingValue(
        myPreviousSettings.showBarbHead,
        AppConst.defaultShowBarbHead,
      ),
      mapStyle: getSettingValue(
        myPreviousSettings.mapStyle,
        AppConst.defaultMapStyle,
      ),
      ignoreMidpoints: getSettingValue(
        myPreviousSettings.ignoreMidpoints,
        AppConst.defaultIgnoreMidpoints,
      ),
    };
  }
  applicationConfig.sanitizeTimeZone();
};
applicationConfig.removePopoverOnresize = () => {
  window.setTimeout(() => {
    d3.select('ion-popover').remove();
  }, 1000);
};
const resetConfigOnResize = () => {
  applicationConfig.showMobileView = !isShowingSideMenu();
  applicationConfig.imageryViewUseSubnav = !isShowingSideMenu();
  applicationConfig.removePopoverOnresize();
};

window.addEventListener('resize', () => {
  if (utilityService.isCordovaApplication()) {
    setTimeout(() => {
      resetConfigOnResize();
    }, 200);
  } else {
    resetConfigOnResize();
  }
});
export default applicationConfig;
